import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { SiteTypeComponent } from './site-type/site-type.component';
import { SaveSiteTypeComponent } from './save-site-type/save-site-type.component';
import { PolymerModule } from '@codebakery/origami';


@NgModule({
  imports: [
    CommonModule,
    PolymerModule
  ],
  exports: [LayoutComponent, SaveSiteTypeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [LayoutComponent, SiteTypeComponent, SaveSiteTypeComponent]
})
export class SiteProfileModule { }
